
import { computed, defineComponent, onBeforeMount } from 'vue';
import { useStore } from 'vuex';
import IoRouterLink from '@/components/IoRouterLink.vue';

export default defineComponent({
  components: {
    IoRouterLink,
  },

  setup() {
    const store = useStore();
    const { themeUri } = window.ioappConfig;

    const { footerLogo } = window.ioappConfig;

    onBeforeMount(() => {
      store.dispatch('menus/fetchBySlug', 'footer-left');
      store.dispatch('menus/fetchBySlug', 'footer-right');
    });

    const menuLeft = computed(() => store.getters['menus/menu']('footer-left'));
    const menuLeftLoading = computed(() => store.getters['menus/status']('footer-left') === 1);
    const menuRight = computed(() => store.getters['menus/menu']('footer-right'));
    const menuRightLoading = computed(() => store.getters['menus/status']('footer-right') === 1);
    const hasKlimaheldSection = computed(() => store.getters['pages/hasKlimaheldSection']);

    return {
      themeUri,
      menuLeft,
      menuLeftLoading,
      menuRight,
      menuRightLoading,
      hasKlimaheldSection,
      footerLogo,
    };
  },
});
